// LOCAL DEVELOPMENT
// import * as slot_core from '@gamzix/slot_core';
//
// Object.entries(slot_core).forEach(([key, value]) => {
//     global[key] = value;
// });
// END OF LOCAL DEVELOPMENT

import './const';
import './GameDataStore';
import './GameSlotGameSubController';

import '../components/bigWin/src/index';
import '../components/preloader/src/index';
import '../components/background/src/index';
import '../components/graphicsLines/src/index';
import '../components/freeSpinsGame/src/index';
import '../components/bonusGame/src/index';
import '../components/reelset/src/index';
import '../components/preview/src/index';
import '../components/jackpotPanel/src/index';
import '../components/coinAnimation/src/index';
import '../components/ui/src/index';
import '../components/intrigue/src/index';
import '../components/winFrames/src/index';
import '../components/reelFrame/src/index';

window.gameRun();
